<template>
  <div
      class="md:flex md:space-x-5 email_height overflow-hidden relative rtl:space-x-reverse"
  >
    <div
        class="flex-1 md:w-[calc(100%-320px)]"
        :class="width < 768 ? 'h-full' : ''"
    >
      <Card
          bodyClass="p-0 h-full  relative"
          :className="width < 1024 ? 'h-full' : ''"
      >
        <div class="all-allEmails px-6 h-full flex flex-col pt-6 pb-4">
          <Transition :enter-active-class="locale === 'fa' ? 'singleEmail-fa-enter-active' : 'singleEmail-enter-active'"
                      :leave-active-class="locale === 'fa' ? 'singleEmail-fa-leave-active' : 'singleEmail-leave-active'"
                      name="singleEmail">
            <div
                class="absolute left-0 top-0 w-full h-full bg-white dark:bg-slate-800 z-[55] rounded-md p-6 overflow-y-auto overflow-x-hidden"
            >
              <Modal
                  :title="modalTitle"
                  labelClass="btn-outline-warning"
                  ref="modal5"
                  themeClass="bg-success-500"
                  :hasButton="false"
                  :activeModal="isShowConfirmationModal"
                  @closeModal="isShowConfirmationModal = false"
                  centered
              >
                <div class="text-base mb-3 text-slate-600 dark:text-slate-300 text-center">
                  {{ modalTitle + " " + selectedApplicant.firstName + " " + selectedApplicant.lastName }}
                </div>
                <h4 class="font-medium text-lg text-slate-900 text-center">
                  {{ $t('message.are you sure?') }}
                </h4>
                <template v-slot:footer>
                  <div class="flex flex-row justify-center align-center w-full space-x-3 rtl:space-x-reverse">
                    <Button
                        :text="$t('message.close')"
                        btnClass="btn-outline-dark "
                        @click="isShowConfirmationModal = false"
                    />
                    <button @click="approve"
                            class="btn text-center flex items-center justify-center gap-3 btn-success">
                      {{ $t('message.accept') }}
                      <Icon v-show="loading" icon="eos-icons:bubble-loading" height="24"/>
                    </button>
                  </div>
                </template>
              </Modal>
              <div
                  class="flex items-center border-b border-slate-100 dark:border-slate-700 -mx-6 pb-6 mb-6 px-6"
              >
                <div class="flex-1">
                  <Tooltip placement="top" arrow>
                    <template #button>
                      <div class="email-icon" @click="closeDetailsEmail">
                        <Icon v-if="locale === 'fa'" icon="heroicons-outline:arrow-right"/>
                        <Icon v-else icon="heroicons-outline:arrow-left"/>
                      </div>
                    </template>
                    <span>{{ $t('message.back') }}</span>
                  </Tooltip>
                </div>

              </div>
              <div>
                <div class="grid grid-cols-1 gap-6">
                  <Tabs :applicantBasicInformation="selectedApplicant"/>
                </div>
                <div class="flex flex-row gap-3 mt-5">
                  <Button
                      :text="$t('message.accept')"
                      btnClass="btn-success"
                      @click="showConfirmationModal(true)"
                  />
                </div>
              </div>
            </div>
          </Transition>
        </div>
      </Card>
    </div>
  </div>
</template>
<script setup>
import Card from "@/components/Card/index.vue";
import {computed, ref, onMounted} from "vue";
import {useEmailStore} from "@/stores/email";
import {useI18n} from "vue-i18n";
import Modal from "@/components/Modal/Modal.vue";
import Tooltip from "@/components/Tooltip/index.vue";
import Button from "@/components/Button/index.vue";
import Tabs from "@/views/manageApplicants/account/applicantDetails/tabs.vue";
import Icon from "@/components/Icon/index.vue";
import Textarea from "@/components/Textarea/index.vue";
import Image from '@/components/Image/index.vue';
import {useToast} from "vue-toastification";
import {useThemeSettingsStore} from "@/stores/themeSettings.js";
import {useManagementStore} from "@/stores/management.js";
import {useRoute, useRouter} from "vue-router";
import {useOrdersStore} from "@/stores/orders.js";

const width = ref(0);
const handleResize = () => {
  width.value = window.innerWidth;
};
onMounted(() => {
  window.addEventListener("resize", handleResize);
  handleResize();
});

let store = useEmailStore();

const {t, locale} = useI18n({useScope: 'global'})

const route = useRoute();
const router = useRouter();
const managementStore = useManagementStore();
const orderStore = useOrdersStore();

const toast = useToast();
const themeSettings = useThemeSettingsStore();
const image = computed(() => {
  return store.image;
});
const closeDetailsEmail = () => {
  store.closeDetailsEmail();
  router.go(-1);
};

const isShowConfirmationModal = ref(false)
const loading = ref(false)

const selectedApplicant = computed(() => managementStore.getSelectedApplicant);

onMounted(() => {
  if (!selectedApplicant.value.id) {
    router.push({name: route.name, params:{orderID:route.params.orderID}})
  }
});

const verificationNote = ref('')
const emit = defineEmits(['updateList'])

async function approve() {
  const approve = await orderStore.action_set_account_order_taker({
    "id": Number(route.params.orderID),
    "takerID": selectedApplicant.value.id,
    "notes": "this is a note"
  })
  if (approve) {
    closeDetailsEmail();
    emit('updateList');
    toast.success('با موفقیت ثبت شد', {
      timeout: 2000,
      rtl: themeSettings.direction,
      toastClassName: "!mr-0 !ml-auto",
    });
  }
}

function showConfirmationModal() {
  isShowConfirmationModal.value = true
}

const modalTitle = computed(() => {

    return t('message.approve') + " " + t('message.information')

});
</script>




<style lang="scss">
.singleEmail-enter-active {
  animation: fade-in-right 0.5s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}

.singleEmail-leave-active {
  animation: fade-in-right 0.5s cubic-bezier(0.39, 0.575, 0.565, 1) both reverse;
}

.singleEmail-fa-enter-active {
  animation: fade-in-left 0.5s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}

.singleEmail-fa-leave-active {
  animation: fade-in-left 0.5s cubic-bezier(0.39, 0.575, 0.565, 1) both reverse;
}

@-webkit-keyframes fade-in-right {
  0% {
    -webkit-transform: translateX(50px);
    transform: translateX(50px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes fade-in-right {
  0% {
    -webkit-transform: translateX(50px);
    transform: translateX(50px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}


@-webkit-keyframes fade-in-left {
  0% {
    -webkit-transform: translateX(-50px);
    transform: translateX(-50px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes fade-in-left {
  0% {
    -webkit-transform: translateX(-50px);
    transform: translateX(-50px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}


@-webkit-keyframes slide-in-right {
  0% {
    -webkit-transform: translateX(1000px);
    transform: translateX(1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slide-in-right {
  0% {
    -webkit-transform: translateX(1000px);
    transform: translateX(1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}

.email_height {
  height: calc(var(--vh, 1vh) * 100 - 12.1rem);
}

@media (max-width: 768px) {
  .email_height {
    height: calc(var(--vh, 1vh) * 100 - 10.5rem);
  }
}

.email-icon {
  @apply h-8 w-8 bg-slate-100 dark:bg-slate-900 dark:text-slate-200 text-slate-600 flex flex-col justify-center items-center text-base rounded-full cursor-pointer;
}

.info-500-list {
  @apply text-xs text-slate-600;
  li {
    @apply flex space-x-2;
    span:nth-child(1) {
      @apply font-medium flex-none text-right;
    }

    span:nth-child(2) {
      @apply flex-1 text-right;
    }
  }
}
</style>